import { getLines } from '../Button'

const LINE_LENGTH_LIMIT = 16

export const getTitleForReminderMissionButton = (
  reminderName: string,
  fallbackText: string,
): string => {
  const [, secondLine] = getLines(reminderName)
  return secondLine.length > LINE_LENGTH_LIMIT ? fallbackText : reminderName
}
